/* eslint-disable */

import React from 'react';
import classNames from 'classnames/bind';
import styles from './Refund.module.scss';

const cx = classNames.bind(styles);

function Refund_05() {
	return (
		<div className={cx('terms')}>
			<h3 className={cx('tit_terms', 'pt0')}>제1조 ( 환불대상 )</h3>
			<p className={cx('cont_terms')}>
				본 약관은 엔카닷컴㈜(이하 “회사”라 함)에서 운영하는 사이트(http://www.encar.com, 웹 및 애플리케이션을 포함함)에서 엔카 홈서비스를
				통하여 구매한 차량에 한하여 적용됩니다.
			</p>

			<h3 className={cx('tit_terms')}>제2조 ( 환불기간 )</h3>
			<p className={cx('cont_terms')}>
				엔카 홈서비스를 이용하여 차량 구매 계약을 체결한 “회사”의 이용자(이하 “고객”이라 함)가 청약철회를 하기 위하여는 차량을 인수한 날부터
				7일내에 “회사”에 환불신청을 해야 하며, 환불신청일 익일(단, 해당일이 국가가 지정한 공휴일인 경우 그 다음날)까지 차량을 “회사”에
				반환하여야 합니다.
			</p>

			<h3 className={cx('tit_terms')}>제3조 ( 환불절차 )</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① “고객”이 제2조에 따라 청약철회를 하고자 하는 경우 차량을 구매한 지점 또는 “회사”가 지정하는 곳으로 구매한 차량을 반환하여야
					합니다.
				</li>
				<li>
					② “회사”는 “고객”이 반환한 차량에 대하여 “회사가 “고객”에게 차량을 인도하면서 작성하여 교부한 차량 상태에 대한 체크리스트를
					기준으로 차량상태를 확인합니다.
				</li>
				<li>
					③ “회사”는 전항에 따라 “체크리스트”를 기준으로 확인한 결과 관계법령 또는 본 약관에 따른 환불 불가 사유에 해당되지 않는 경우
					“고객”의 환불 신청에 대하여 처리를 수락합니다.
				</li>
				<li>
					④ “회사”가 “고객”의 환불요청을 수락하기로 결정한 경우 [차량구매대금, 취등록세 및 홈서비스 이용료(별첨 2에 따름)를 합한
					금액(“고객”이 보증상품을 구매한 경우 보증상품 구매비용을 포함함)]에서 [“고객”이 차량 사용으로 얻은 이익(별첨1에 따름)]을 제한
					금액을 반환하기로 합니다. 단, 기타 공제 사유가 있는 경우 해당 대금도 공제하며 반환 대금 산정 내역은 “회사”가 “고객”에게 별도로
					고지하기로 합니다.
				</li>
				<li>
					⑤ “회사”는 전항에 따라 산정된 반환 대금을 계좌이체 방식으로 차량대금을 지급한 “고객”에게는 3영업일 이내에 “고객”이 지정한
					환불계좌로 반환하며, 카드결제 또는 대출의 방식으로 차량 대금을 지급한 “고객”에게는 환불이 결정되는 즉시 결제수단을 제공한
					사업자에게 대금 청구를 정지하거나 취소하도록 요청합니다. 단, 카드결제 또는 대출 방식으로 금융사에서 결제 취소를 해야 하는 경우
					공제금액을 “고객”이 “회사”에 선지급한 후 결제 취소를 요청하는 것을 원칙으로 하며, “고객”이 원하는 경우 일부에 한하여 카드결제 및
					대출을 취소할 수 있습니다.
				</li>
				<li>
					⑥ 차량을 인수한 시점부터 “고객”이 환불 신청을 위하여 “회사”에 차량을 반환하는 시기까지 발생되는 속도위반 과태료, 주정차위반 과태료
					또는 하이패스 미납요금 등 법적, 행정적 사유에 따른 모든 비용은 환불 신청 시까지 ”고객”이 납부를 완료하여야 합니다. 만약 “고객”이
					해당 비용을 납부하지 않을 경우 “회사”는 환불 대금에서 해당 비용을 공제할 수 있으며, 미납으로 인한 모든 책임은 “고객”이 부담합니다.
				</li>
				<li>
					⑦ “고객”은 제2조에 따른 환불기간 내에 “고객”이 차량 구매 시 “회사”와 별도로 체결하였던 대출계약 또는 자동차보험계약 등의
					해지절차를 진행해야 합니다. 만약 “고객”이 환불기간 내 대출계약 또는 자동차보험계약 등을 해지하지 않은 경우 환불이 불가합니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>제4조 ( 환불 기준 )</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① “회사”가 제3조 제2항에 따라 반환된 차량을 확인한 결과 “체크리스트”를 기준으로 멸실, 훼손되거나 “고객”의 사용 등의 책임있는
					사유로 차량의 가치가 현저히 감소한 경우 환불 처리가 불가합니다.
				</li>
				<li>
					② 본 조 제1항의 규정에도 불구하고 실내 또는 외관의 단순 파손만 있는 경우(성능점검 상 외판 부위 또는 주요골격 부위의 판금이나
					교환이 발생하지 않은 상태인 경우에 한함) "고객", "회사", "차량판매자"의 합의에 따라 환불처리를 할 수 있으며, 이때 환불되는 금액은
					“회사”의 제휴정비망을 통해 산출된 차량 수리 실비를 공제한 금액으로 합니다.
				</li>
				<li>
					③ “고객”이 차량 인수 후 해당 차량을 범죄에 이용하거나, 차량 부품의 고의적인 파손 및 교체가 있었음을 “회사”가 확인한 경우, 환불
					대상에서 제외됩니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>제5조 ( 환불이 불가한 비용 )</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① “고객”이 엔카 홈서비스 신청 시 필수적으로 발생하는 탁송 비용은 탁송업체에게 지불되는 일회성 비용으로 아래 기준에 따라 환불이
					불가할 수 있습니다. 단, “회사”의 고의 또는 중대한 과실로 인한 환불신청 건의 경우 예외로 합니다.
				</li>
				<li>
					<div className={cx('scroll_tbl')}>
						<table className={cx('tbl_refund', 'ver3')}>
							<colgroup>
								<col width="50%" />
								<col width="50%" />
							</colgroup>
							<thead>
								<tr>
									<th scope="col">탁송당일</th>
									<th scope="col">환불수수료</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>출발시간 2시간 전 취소</td>
									<td>편도 탁송비의 50%</td>
								</tr>
								<tr>
									<td scope="col">출발시간 1시간 전 취소</td>
									<td scope="col">편도 탁송비의 100%</td>
								</tr>
								<tr>
									<td scope="col">출발 후 취소</td>
									<td scope="col">왕복 탁송비 전액 환불 불가</td>
								</tr>
							</tbody>
						</table>
					</div>
				</li>
				<li>
					② 차량 인수 후 임의의 추가 장착품 및 차량에 투입된 비용에 대해서는 환불이 불가합니다. (예.블랙박스 장착비용, 썬팅비용, 타이어
					교체비용, 각종 오일 교체비용, 광택 및 세차비용, 주유비, 통행료 등 차량에 투입된 비용) 다만, 장착품 중 탈거가 가능한 경우 탈거 후
					반환은 가능합니다.
				</li>
				<li>
					③ 제3조 제7항에 따라 “고객”이 차량 구매 시에 대출계약 또는 자동차보험계약 등을 해지함으로 인하여 발생하는 비용은 환불이
					불가합니다.
				</li>
				<li>
					④ “고객” 또는 “차량판매자”의 해약금은 매매계약 체결 당시 약정에 따라 다음 각 호의 경우를 제외하고는 환불 또는 보상대상에서
					제외됩니다. 단, 본 항의 규정은 탁송료, [“고객”이 차량 사용으로 얻은 이익(별첨 1 에 따름)] 및 손해배상 청구에 영향을 미치지
					않습니다.
				</li>
				<li>
					1. “차량판매자” 또는 “회사”가 “고객”에게 차량을 인도한 날로부터 7 일 이내 “고객”의 귀책사유가 없음에도 일방적으로 계약을
					해지/해제한 경우
				</li>
				<li>2. “고객”의 귀책으로 인해 차량 환불 처리가 불가능함에도 “차량판매자”가 환불을 허용한 경우</li>
			</ul>

			<h3 className={cx('tit_terms')}>제6조 ( 서비스 이용제한 )</h3>
			<p className={cx('cont_terms')}>
				“회사”는 악의적으로 환불 처리를 이용하는 계약자(365일 이내 2회 이상 환불을 시행하는 것을 뜻함)에 대하여 엔카 홈서비스 이용을 제한할 수
				있습니다.
			</p>

			<h3 className={cx('tit_terms')}>[별첨1] 환불신청 일자별 “고객”의 사용으로 얻은 이익 기준 표</h3>
			<div className={cx('scroll_tbl')}>
				<table className={cx('tbl_refund', 'ver2')}>
					<colgroup>
						<col width="15%" />
						<col width="10%" />
						<col width="10%" />
						<col width="10%" />
						<col width="10%" />
						<col width="10%" />
						<col width="10%" />
						<col width="10%" />
						<col width="*" />
					</colgroup>
					<thead>
						<tr>
							<th
								scope="col"
								className={cx('first')}
							>
								차종
							</th>
							<th scope="col">1일</th>
							<th scope="col">2일</th>
							<th scope="col">3일</th>
							<th scope="col">4일</th>
							<th scope="col">5일</th>
							<th scope="col">6일</th>
							<th scope="col">7일</th>
							<th scope="col">주행 100km당</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td className={cx('first')}>경형(국산)</td>
							<td rowSpan="2">재상품화비용</td>
							<td rowSpan="2">재상품화비용</td>
							<td rowSpan="2">재상품화비용</td>
							<td rowSpan="2">160,000</td>
							<td rowSpan="2">200,000</td>
							<td rowSpan="2">240,000</td>
							<td rowSpan="2">280,000</td>
							<td rowSpan="2">15,000</td>
						</tr>
						<tr>
							<td className={cx('first')}>소형(국산)</td>
						</tr>
						<tr>
							<td className={cx('first')}>준중형(국산)</td>
							<td rowSpan="2">재상품화비용</td>
							<td rowSpan="2">재상품화비용</td>
							<td rowSpan="2">재상품화비용</td>
							<td rowSpan="2">200,000</td>
							<td rowSpan="2">250,000</td>
							<td rowSpan="2">300,000</td>
							<td rowSpan="2">350,000</td>
							<td rowSpan="2">20,000</td>
						</tr>
						<tr>
							<td className={cx('first')}>중형(국산)</td>
						</tr>
						<tr>
							<td className={cx('first')}>준대형(국산)</td>
							<td>재상품화비용</td>
							<td>재상품화비용</td>
							<td>재상품화비용</td>
							<td>300,000</td>
							<td>375,000</td>
							<td>450,000</td>
							<td>525,000</td>
							<td>25,000</td>
						</tr>
						<tr>
							<td className={cx('first')}>대형(국산)</td>
							<td>재상품화비용</td>
							<td>재상품화비용</td>
							<td>재상품화비용</td>
							<td>400,000</td>
							<td>500,000</td>
							<td>600,000</td>
							<td>700,000</td>
							<td>35,000</td>
						</tr>
						<tr>
							<td className={cx('first')}>소형SUV(국산)</td>
							<td rowSpan="4">재상품화비용</td>
							<td rowSpan="4">재상품화비용</td>
							<td rowSpan="4">재상품화비용</td>
							<td rowSpan="4">280,000</td>
							<td rowSpan="4">350,000</td>
							<td rowSpan="4">420,000</td>
							<td rowSpan="4">490,000</td>
							<td rowSpan="4">25,000</td>
						</tr>
						<tr>
							<td className={cx('first')}>중형SUV(국산)</td>
						</tr>
						<tr>
							<td className={cx('first')}>RV(국산)</td>
						</tr>
						<tr>
							<td className={cx('first')}>승합(국산)</td>
						</tr>
						<tr>
							<td className={cx('first')}>수입차</td>
							<td>재상품화비용</td>
							<td>재상품화비용</td>
							<td>재상품화비용</td>
							<td>400,000</td>
							<td>500,000</td>
							<td>600,000</td>
							<td>700,000</td>
							<td>35,000</td>
						</tr>
						<tr>
							<td className={cx('first')}>
								5천만원이상
								<br />
								(국산/수입)
							</td>
							<td>재상품화비용</td>
							<td>400,000</td>
							<td>600,000</td>
							<td>800,000</td>
							<td>1,000,000</td>
							<td>1,200,000</td>
							<td>1,400,000</td>
							<td>50,000</td>
						</tr>
						<tr>
							<td className={cx('first')}>
								1억원이상
								<br />
								(국산/수입)
							</td>
							<td>재상품화비용</td>
							<td>800,000</td>
							<td>1,600,000</td>
							<td>2,400,000</td>
							<td>3,000,000</td>
							<td>3,600,000</td>
							<td>4,200,000</td>
							<td>100,000</td>
						</tr>
					</tbody>
				</table>
			</div>

			<h3 className={cx('tit_terms')}>
				* 재상품화 비용 : 고객이 환불 진행 시 차량판매자에게 지급되는 차량 재성능점검, 세차 등의 비용(국산차 10만원, 수입차 15만원으로 산정)
			</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① 1일차(인수일 기준) ~ 3일차까지는 “재상품화비용”
					<p>※ 단, 5천만원이상(국산/수입 불문) 차량은 2일차부터 위 표에 따른 차량이용료 부과</p>
				</li>
				<li>② 4일차 ~ 7일차까지는 “재상품화비용” 및 위 표에 따른 차량이용료 부과</li>
				<li>
					③ 위 차량이용료와 별도로 주행거리가 100Km를 초과할 경우 위 표 우측에 따른 구간별 사용료 부과
					<p>※ 주행거리는 1일차(인수일 기준)부터 적용하여 산정</p>
				</li>
				<li>
					④ “고객”이 차량 반납 시 본 환불약관 제 3조 3항에 따른 환불 불가 사유에 해당하는 경우 또는 본 환불약관 4조 1항 및 3항에 해당하는
					경우 환불이 불가합니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>[별첨2] 엔카 홈서비스&middot;방문픽업 서비스 이용료</h3>
			<div className={cx('scroll_tbl')}>
				<table
					className={cx('tbl_refund')}
					style={{ width: '100%', minWidth: 500 }}
				>
					<colgroup>
						<col width="15%" />
						<col width="20%" />
						<col width="25%" />
						<col width="*" />
					</colgroup>
					<thead>
						<tr>
							<th
								scope="col"
								colSpan="2"
								className={cx('first')}
							>
								구분
							</th>
							<th scope="col">
								홈서비스 이용료
								<br />
								(탁송료 별도)
							</th>
							<th scope="col">홈서비스 방문 픽업 이용료</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td
								rowSpan="2"
								className={cx('first')}
							>
								국산
							</td>
							<td>5 천만원 미만</td>
							<td>110,000</td>
							<td rowSpan="4">차량가액의 0.5&#37;</td>
						</tr>
						<tr>
							<td>5 천만원 이상</td>
							<td>220,000</td>
						</tr>
						<tr>
							<td
								rowSpan="2"
								className={cx('first')}
							>
								수입
							</td>
							<td>5 천만원 미만</td>
							<td>110,000</td>
						</tr>
						<tr>
							<td>5 천만원 이상</td>
							<td>220,000</td>
						</tr>
					</tbody>
				</table>
			</div>
			<h3 className={cx('tit_terms')}>
				* 홈서비스 환불약관 제 3조 4항에 따라 “회사”가 “고객”의 환불요청을 수락한 경우 해당 이용료도 반환됩니다.
			</h3>

			<p className={cx('tit_terms')}>부칙</p>
			<p className={cx('cont_terms')}>가. 이 약관은 2022년 08월 30일 부터 시행합니다.</p>
			<p className={cx('cont_terms')}>나. 이 약관은 2023년 08월 01일부터 시행합니다.</p>
		</div>
	);
}

export default Refund_05;
